import {NutrientType} from "@/models/Ingredient/NutrientType";
import {NutritionLabelCountry} from "@/models/NutritionLabels/NutritionLabelCountry";

export const OPTIONAL_CORE_NUTRIENTS = [
  NutrientType.SaturatedFattyAcids,
  NutrientType.TransFattyAcids,
  NutrientType.Fibre,
  NutrientType.Sugars,
  NutrientType.Cholesterol,
  NutrientType.Sodium,
  NutrientType.Potassium,
  NutrientType.Calcium,
  NutrientType.Iron
];

export const OPTIONAL_CORE_SUPPLEMENT_NUTRIENTS = [
  NutrientType.Energy,
  NutrientType.Fat,
  NutrientType.SaturatedFattyAcids,
  NutrientType.TransFattyAcids,
  NutrientType.Cholesterol,
  NutrientType.Sodium,
  NutrientType.Carbohydrate,
  NutrientType.Fibre,
  NutrientType.Sugars,
  NutrientType.AddedSugar,
  NutrientType.Protein,
  NutrientType.Potassium,
  NutrientType.Calcium,
  NutrientType.Iron
];

export const SUPPLEMENT_NUTRIENTS = [
  NutrientType.Biotin,
  NutrientType.Choline,
  NutrientType.Folate,
  NutrientType.Niacin,
  NutrientType.PantothenicAcid,
  NutrientType.Riboflavin,
  NutrientType.Thiamine,
  NutrientType.BetaCarotene,
  NutrientType.Retinol,
  NutrientType.VitaminB6,
  NutrientType.VitaminB12,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.Chromium,
  NutrientType.Chloride,
  NutrientType.Copper,
  NutrientType.Iodine,
  NutrientType.Magnesium,
  NutrientType.Manganese,
  NutrientType.Molybdenum,
  NutrientType.Phosphorus,
  NutrientType.Selenium,
  NutrientType.Zinc,
  NutrientType.LAlanine,
  NutrientType.LArginine,
  NutrientType.LAsparagine,
  NutrientType.LAsparticAcid,
  NutrientType.LCysteine,
  NutrientType.LGlutamicAcid,
  NutrientType.LGlutamine,
  NutrientType.Glycine,
  NutrientType.LHistidine,
  NutrientType.LIsoleucine,
  NutrientType.LLeucine,
  NutrientType.LLysine,
  NutrientType.LMethionine,
  NutrientType.LPhenylalanine,
  NutrientType.LProline,
  NutrientType.LSerine,
  NutrientType.LThreonine,
  NutrientType.LTyrosine,
  NutrientType.LValine,
  NutrientType.Caffeine,
  // NutrientType.Taurine,
  // NutrientType.Phosphatidylserine,
  // NutrientType.FolicAcid,
  // NutrientType.Boron,
  // NutrientType.Fluoride,
  // NutrientType.Tryptophan,
];

const UK_VOLUNTARY_NUTRIENTS = [
  NutrientType.Iron,
  NutrientType.Calcium
];

const US_VOLUNTARY_NUTRIENTS = [
  NutrientType.VitaminA,
  NutrientType.VitaminC,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.Thiamine,
  NutrientType.Riboflavin,
  NutrientType.Niacin,
  NutrientType.VitaminB6,
  NutrientType.Folate,
  NutrientType.VitaminB12,
  NutrientType.Biotin,
  NutrientType.PantothenicAcid,
  NutrientType.Phosphorus,
  NutrientType.Iodine,
  NutrientType.Magnesium,
  NutrientType.Zinc,
  NutrientType.Selenium,
  NutrientType.Copper,
  NutrientType.Manganese,
  NutrientType.Chromium,
  NutrientType.Molybdenum,
  NutrientType.Chloride,
  NutrientType.Choline,
];

const CANADA_VOLUNTARY_NUTRIENTS = [
  NutrientType.VitaminA,
  NutrientType.VitaminC,
  NutrientType.VitaminD,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.Thiamine,
  NutrientType.Riboflavin,
  NutrientType.Niacin,
  NutrientType.VitaminB6,
  NutrientType.Folate,
  NutrientType.VitaminB12,
  NutrientType.Biotin,
  NutrientType.PantothenicAcid,
  NutrientType.Choline,
  NutrientType.Phosphorus,
  NutrientType.Iodine,
  NutrientType.Magnesium,
  NutrientType.Zinc,
  NutrientType.Selenium,
  NutrientType.Copper,
  NutrientType.Manganese,
  NutrientType.Chromium,
  NutrientType.Molybdenum,
  NutrientType.Chloride,
];

/**
 * Returns the voluntary nutrients for a given country.
 * @param country
 */
export function getVoluntaryNutrients(country: NutritionLabelCountry) {
  switch (country) {
    case NutritionLabelCountry.Canada:
      return CANADA_VOLUNTARY_NUTRIENTS;
    case NutritionLabelCountry.US:
      return US_VOLUNTARY_NUTRIENTS;
    case NutritionLabelCountry.UK:
      return UK_VOLUNTARY_NUTRIENTS;
  }
}